import Vue from 'vue';
import productTransformer from './../../transformers/productSearch';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const products = productTransformer.fetchCollection(data.data);
  resolve(products);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('products/search/all/products', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/searchAll.js